"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Code.default;
  }
});

var _Code = _interopRequireDefault(require("./Code"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }